<template>
  <v-container
    id="products"
    tag="section"
  >
    <base-material-card
      color="indigo"
      icon="mdi-animation"
      inline
      class="px-5 py-3"
      top-actions
    >
      <template v-slot:after-heading>
        <div class="display-2 font-weight-light">
          Products
        </div>
      </template>

      <template v-slot:top-actions>
        <v-btn
          class="px-2 ml-1"
          color="info"
          @click="refreshProducts()"
        >
          Refresh
        </v-btn>
      </template>

      <v-text-field
        v-model="search"
        append-icon="mdi-magnify"
        class="ml-auto"
        label="Search"
        hide-details
        single-line
        style="max-width: 250px;"
      />

      <v-divider class="mt-3" />

      <v-data-table
        :headers="headers"
        :items="items"
        :search.sync="search"
        :sort-desc="[false, false]"
        multi-sort
        class="row-action"
      >
        <template v-slot:item="{ item }">
          <tr @click="gotoDetails(item)">
            <td>
              <v-btn
                class="px-2 ml-1"
                color="info"
                rounded
                small
                @click.stop="gotoDetails(item)"
              >
                Details
              </v-btn>
              <v-btn
                class="px-2 ml-1"
                color="success"
                rounded
                small
                @click.stop="gotoNew(item)"
              >
                Add to basket
              </v-btn>
            </td>
            <td>{{ item.vendor }}</td>
            <td>{{ item.displayName }}</td>
          </tr>
        </template>
      </v-data-table>
    </base-material-card>
  </v-container>
</template>

<script>
  import { mapGetters } from 'vuex'

  export default {
    data: () => ({
      headers: [
        {
          sortable: false,
          text: '',
          align: 'left',
          width: '180',
        },
        {
          sortable: true,
          text: 'Vendor',
          value: 'vendor',
        },
        {
          sortable: true,
          text: 'Product',
          value: 'displayName',
        },
      ],
      search: undefined,
    }),
    computed: {
      items () {
        return this.$store.state.products.list.map(item => {
          return {
            ...item,
            vendor: this.getVendorNameById(item.vendorId),
          }
        })
      },
      ...mapGetters(['getVendorNameById']),
    },
    created: function () {
      if (this.$store.state.products.list.length === 0) {
        this.refreshProducts()
      }
    },
    methods: {
      async refreshProducts () {
        this.$store.dispatch('RefreshProducts')
      },
      gotoDetails (item) {
        this.$router.push({ name: 'Product', params: { uid: item.uid } })
      },
      gotoNew (item) {
        this.$router.push({
          name: 'ProductOrder',
          params: { productUid: item.uid },
        })
      },
    },
  }
</script>
